export const messages = {
  title: '纪念日',
  birthday: '生日',
  anniversary: '纪念日',
  lunar: '农历',
  solar: '公历',
  add: '添加',
  edit: '编辑',
  delete: '删除',
  confirmDelete: '确认删除这条纪念日？',
  cancel: '取消',
  save: '保存',
  namePlaceholder: '名称',
  datePlaceholder: '日期 (YYYY-MM-DD)',
  empty: '还没有纪念日，添加一个吧'
} as const
